import React, { useState, useMemo } from "react";
import { INDUSTRIES, INDUSTRY_CONTENT } from "@/mock";
import { Card } from "@/components/ui/card";
import { Check, Sparkles } from "lucide-react";
import { DEFAULT_SITE_COPY, useSiteCopy, PageShell, PrimaryCTA, ResponseBadge, VerticalSwitcher, ThreeBlocks } from "./publicShared";

export const IndustriesContent = () => {
  const [vertical, setVertical] = useState("medical");
  const { copy } = useSiteCopy();

  const industryOverrides = copy.industries || {};
  const getIndustry = (key) => ({
    ...INDUSTRY_CONTENT[key],
    ...(industryOverrides?.[key] || {})
  });

  const selected = useMemo(
    () => INDUSTRIES.find((i) => i.key === vertical),
    [vertical]
  );

  return (
    <PageShell>
      <h1 className="text-3xl font-semibold tracking-tight text-foreground dark:text-white">
        Industries
      </h1>
      <p className="mt-3 max-w-2xl text-foreground/65 dark:text-white/65">
        The homepage stays universal. Here are tailored examples to make the
        conversation concrete.
      </p>

      <div className="mt-10">
        <Card className="rounded-3xl border-border/60 dark:border-white/10 bg-background/60 dark:bg-white/5 p-6 backdrop-blur-2xl">
          <VerticalSwitcher value={vertical} onChange={setVertical} />
          <div className="mt-6 text-lg font-semibold text-foreground dark:text-white">
            {selected?.label} examples
          </div>
          <div className="mt-4">
            <ThreeBlocks
              verticalKey={vertical}
              getIndustryContent={getIndustry} />

          </div>
          <div className="mt-6 rounded-2xl border border-border/60 dark:border-white/10 bg-muted/60 dark:bg-black/30 p-4 text-sm text-foreground/65 dark:text-white/65">
            Dedicated vertical pages will come later for SEO + credibility.
          </div>
        </Card>
      </div>

      <div className="mt-12">
        <PrimaryCTA copy={copy} />
      </div>
    </PageShell>);

};

